export default "__VITE_ASSET__P74mf8zt__"